import { IOpObject, IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Enums } from '../common/enums'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpLanguage } from '../../models/core/op-language'


export class OpAlarmMessage implements IOpChangeState, IJsonSerializable {
    //Properties
    public idAlarmEvent: number
    public idLanguage: number
    public alarmMessage: string
    //Properties end
    //NavigationProperties
    public language: OpLanguage
    //NavigationProperties end
    //CustomProperties
    //CustomProperties end

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idAlarmEvent = opObj.ID_ALARM_EVENT
            this.idLanguage = opObj.ID_LANGUAGE
            this.alarmMessage = opObj.ALARM_MESSAGE

            if (opObj._Language)
                this.language = new OpLanguage(opObj._Language)

            this.opState = opObj.OpState
        }

    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_ALARM_EVENT: this.idAlarmEvent,
            ID_LANGUAGE: this.idLanguage,
            ALARM_MESSAGE: this.alarmMessage,
            OpState: this.opState
        }
    }

    public toString() {
        return this.alarmMessage
    }
    //IOpObject implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpAlarmMessage[]) {
        if (dataProvider && list && list.length > 0) {
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdLanguage]).then(dict => {
                var languageDict: Dictionary<OpLanguage> = new Dictionary<OpLanguage>(null)
                if (dict.containsKey(Enums.ReferenceType.IdLanguage)) {
                    languageDict = <Dictionary<OpLanguage>>dict.tryGetValue(Enums.ReferenceType.IdLanguage)
                }

                list.forEach(item => {
                    item.language = languageDict.tryGetValue(item.idLanguage)
                })
            })
        }
    }
}